import { addDays, isSameDay, startOfDay } from 'date-fns';

export type ServiceColor = 'red' | 'green' | 'blue' | 'none';

export function getServiceRowColor(now: Date, startDate: Date, completedSlam: boolean): ServiceColor {
  now = startOfDay(now);
  startDate = startOfDay(startDate);

  return isSameDay(startDate, now) && completedSlam
    ? 'green'
    : isSameDay(startDate, now)
      ? 'red'
      : startDate >= addDays(now, 1) && startDate < addDays(now, 2)
        ? 'blue'
        : 'none';
}
